(function($, undefined) {
	'use strict';
	var win = $(window);
	var body;
	
	var winWidth;
	var winHeight;

	var toggleTooltip = function() {
		var t = $(this);
		var assocTooltip = $('.tooltip-big-ctn[data-id="'+t.attr('data-id')+'"]');
		var isShown;
		
		if (assocTooltip.length > 1) {
			assocTooltip = t.closest('.tooltip-outer-ctn').find('.tooltip-big-ctn[data-id="'+t.attr('data-id')+'"]');
		}
		isShown = assocTooltip.hasClass('show');
		
		$('.tooltip-big-ctn').removeClass('show');
		if (!isShown) {
			assocTooltip.addClass('show');
			body.on('click', outsideTooltipClose);
		} else {
			body.off('click', outsideTooltipClose);
		}
	};
	
	var outsideTooltipClose = function(e) {
		if (e !== undefined) {
			if (!$(e.target).closest('.tooltip-big-ctn').length && !$(e.target).closest('.toggle-tooltip-btn').length && !$(e.target).closest('.popover').length && !$(e.target).closest('.tour-backdrop').length) {
				closeAllTooltips();
				body.off('click', outsideTooltipClose);
			}
		} else {
			closeAllTooltips();
		}
	};
	
	var closeAllTooltips = function () {
		$('.tooltip-big-ctn').removeClass('show');
	};
	
	var resetTooltips = function () {
		var tooltips = $('.tooltip-big-ctn:not(.no-reset)');
		
		tooltips.each(function () {
			var t = $(this);
			var assocItem = $('.toggle-tooltip-btn[data-id="'+t.attr('data-id')+'"]');
			body.append(tooltips);
			
			if (assocItem.length) {
                var innerCtn = $('.tooltip-ctn', t);
                var pos = assocItem.offset();
                
				if (innerCtn.hasClass('bottom')) {
					t.css({
						top: pos.top,
						left: pos.left + (assocItem.outerWidth() / 2)
					});
				} else if (innerCtn.hasClass('top')) {
					t.css({
						top: pos.top + assocItem.outerHeight(),
						left: pos.left + (assocItem.outerWidth() / 2)
					});
				}
			}
		});
	};

	var init = function() {
		winWidth = win.width();
		winHeight = win.height();
		body = $('body');
		
		body.on('click', '.toggle-tooltip-btn', toggleTooltip);
		
		setTimeout(resetTooltips, 250);
		
		win.resize(function() {
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();
				resetTooltips();
			}
		});
	};
	
	$(window).ready(init);
	
	Fw.component.export('tooltip', {
		resetTooltips: resetTooltips,
		outsideTooltipClose: outsideTooltipClose
	});

})(jQuery);

